module.exports = __webpack_public_path__ + "static/media/logo.8583e1a5.png";